// The failed-charge cap of the insufficient-funds retry: the retry maximum never exceeds the
// charge that failed. Shared by the gateway limits and the classic retry limits.
export const applyFailedChargeCap = (
  max: number | null | undefined,
  currency: string | null | undefined,
  resultOfPay: Record<string, any> | null | undefined,
) => {
  const transaction = resultOfPay?.transaction || {};
  const isInsufficientFunds =
    resultOfPay?.retry_scenario === 'insufficient_funds_retry' ||
    (!!(transaction.retry_settings || resultOfPay?.retry_settings) &&
      (transaction.error_message?.toLowerCase().includes('insufficient funds') ||
        transaction.message?.toLowerCase().includes('insufficient funds')));

  if (isInsufficientFunds) {
    const retryAmount =
      currency?.toUpperCase() === transaction.charge_currency?.toUpperCase()
        ? Number(transaction.charge_amount)
        : currency?.toUpperCase() === transaction.currency?.toUpperCase()
          ? Number(transaction.amount)
          : null;

    if (retryAmount !== null && !isNaN(retryAmount) && retryAmount > 0) {
      if (max === null || retryAmount < (max as number)) {
        return retryAmount;
      }
    }
  }

  return max;
};
